import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id", "data-session-id"]
const _hoisted_2 = { class: "card-header text-center fw-bold text-bg-primary" }
const _hoisted_3 = { class: "card-body d-flex flex-column justify-content-between" }
const _hoisted_4 = { class: "mb-2 small session-date" }
const _hoisted_5 = { class: "d-block d-lg-inline-block ms-0 ms-lg-2 session-time" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "my-3 d-flex flex-wrap session-categories" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "session-speakers" }
const _hoisted_11 = ["data-speaker-id"]
const _hoisted_12 = { class: "mb-1 speaker-role" }
const _hoisted_13 = { class: "badge text-bg-dark rounded" }
const _hoisted_14 = { class: "row gx-0 gy-2 gx-lg-2" }
const _hoisted_15 = { class: "order-2 order-lg-1 col-12 col-lg-3 text-center speaker-photo" }
const _hoisted_16 = { class: "pe-lg-2 speaker-photo-figure" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "small" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 0,
  class: "fw-bold speaker-name"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 small fw-normal" }, "氏", -1)
const _hoisted_24 = {
  key: 0,
  class: "order-1 order-lg-3 col-12 col-lg-4 p-2 pt-0 text-center speaker-logo-box"
}
const _hoisted_25 = { class: "speaker-logo-figure" }
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 0,
  class: "mb-2 row row-cols-1 gx-0 gy-2 g-lg-2"
}
const _hoisted_28 = {
  key: 0,
  class: "col text-center session-zoom"
}
const _hoisted_29 = { class: "icon icon-start icon-me-2 icon-zoom" }
const _hoisted_30 = {
  key: 1,
  class: "col text-center session-zoom-alt"
}
const _hoisted_31 = { class: "icon icon-start icon-me-2 icon-movie" }
const _hoisted_32 = {
  key: 2,
  class: "col text-center"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "icon icon-start icon-me-2 icon-document" }
const _hoisted_35 = {
  key: 1,
  class: "btn btn-sm btn-secondary w-100 disabled session-document pe-none",
  disabled: ""
}
const _hoisted_36 = { class: "icon icon-start icon-me-2 icon-document" }
const _hoisted_37 = {
  key: 2,
  class: "btn btn-sm btn-outline-secondary w-100 disabled session-document pe-none",
  disabled: ""
}
const _hoisted_38 = { class: "icon icon-start icon-me-2 icon-document" }
const _hoisted_39 = { class: "row row-cols-1 row-cols-lg-2 gx-0 gy-2 g-lg-2 justify-content-center" }
const _hoisted_40 = {
  key: 0,
  class: "col text-center"
}
const _hoisted_41 = {
  key: 1,
  class: "col text-center"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-start icon-me-2 icon-add" }, "視聴リストに追加", -1)
const _hoisted_43 = {
  key: 0,
  class: "small d-block text-center"
}
const _hoisted_44 = {
  key: 1,
  type: "button",
  class: "h-100 text-nowrap btn-cols-max btn btn-accent2 w-100 session-add disabled text-white",
  disabled: "disabled"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-start icon-me-2 icon-remove" }, "視聴リストから削除", -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-start icon-me-2 icon-remove" }, "視聴をキャンセル", -1)
const _hoisted_48 = [
  _hoisted_47
]



  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'SessionView',
  props: {
    session: { type: Object },
    isFilteredSession: { type: Boolean },
    isFiltered: { type: Boolean },
    login: { type: Boolean },
    isCartInSession: { type: Boolean },
    isEnrtySession: { type: Boolean },
    webinarMainLabel: { type: String },
    webinarSubLabel: { type: String },
    eventHolding: { type: Boolean },
    eventAPIisAlive: { type: Boolean }
  },
  emits: ['addItem', 'removeItem', 'cancelItem', 'openLinkWithNewWindow', 'openExternalLink', 'openExternalLinkWithNewWindow'],
  setup(__props, { emit: emits }) {

const props = __props;

  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  

  const addItem = (id: string) => {
    emits('addItem', id);
  }

  const removeItem = (id: string) => {
    emits('removeItem', id);
  }

  const cancelItem = (session: object) => {
    emits('cancelItem', session);
  }

  const openLinkWithNewWindow = (url: string) => {
    emits('openLinkWithNewWindow', url);
  }

  // eslint-disable-next-line
  const openExternalLink = (url: string) => {
    emits('openExternalLink', url);
  }

  const openExternalLinkWithNewWindow = (url: string) => {
    emits('openExternalLinkWithNewWindow', url);
  }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (__props.session.id)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([[__props.isFiltered ? __props.isFilteredSession ? '' : 'opacity-25' : '', __props.isCartInSession ? 'bg-cartin-session' : '', __props.isEnrtySession ? 'bg-entry-session' : ''], "h-100 card border-primary text-decoration-none text-dark card-session card-session-sessionview"]),
        id: 'session-' + __props.session.id,
        "data-session-id": __props.session.id,
        onClick: _cache[5] || (_cache[5] = ($event: any) => (__props.session.dtlable_status ? openLinkWithNewWindow('?seminar_session=seminar_' + __props.session.id) : false))
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.session.label), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(__props.session.date), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(__props.session.timeStart) + "〜" + _toDisplayString(__props.session.timeEnd), 1)
            ]),
            _createElementVNode("div", {
              class: "fs-5 fw-bold session-title",
              innerHTML: __props.session.title
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.session.categories, (category, o) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: o,
                  class: "me-2 badge border text-bg-light rounded text-nowrap mb-1"
                }, _toDisplayString(category), 1))
              }), 128))
            ]),
            _createElementVNode("div", {
              class: "my-3 small session-description",
              innerHTML: __props.session.description
            }, null, 8, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.session.speakers, (speaker, o) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(o === __props.session.speakers.length - 1 ? 'session-speaker': 'mb-3 session-speaker'),
                    key: o,
                    "data-speaker-id": o+1
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(speaker.role), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("figure", _hoisted_16, [
                          _createElementVNode("img", {
                            src: speaker.photo,
                            class: "profile-photo",
                            alt: ""
                          }, null, 8, _hoisted_17)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["order-3 order-lg-2 col-12 speaker-info-box", speaker.logo ? 'col-lg-5' : 'col-lg-9'])
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          (speaker.company)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "speaker-company",
                                innerHTML: speaker.company
                              }, null, 8, _hoisted_19))
                            : _createCommentVNode("", true),
                          (speaker.department)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "speaker-department",
                                innerHTML: speaker.department
                              }, null, 8, _hoisted_20))
                            : _createCommentVNode("", true),
                          (speaker.jobtitle)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "speaker-jobtitle",
                                innerHTML: speaker.jobtitle
                              }, null, 8, _hoisted_21))
                            : _createCommentVNode("", true)
                        ]),
                        (speaker.name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createTextVNode(_toDisplayString(speaker.name), 1),
                              _hoisted_23
                            ]))
                          : _createCommentVNode("", true)
                      ], 2),
                      (speaker.logo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("figure", _hoisted_25, [
                              _createElementVNode("img", {
                                src: speaker.logo,
                                class: "img-fluid w-100 speaker-logo",
                                alt: ""
                              }, null, 8, _hoisted_26)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_11))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            (__props.login)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  (__props.eventHolding && __props.isEnrtySession && __props.session.watch && __props.session.webinarMainURL && __props.webinarMainLabel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (openExternalLinkWithNewWindow(__props.session.webinarMainURL)), ["stop","prevent"])),
                          class: "btn btn-lg rounded-1 btn-accent w-100"
                        }, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(__props.webinarMainLabel), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.eventHolding && __props.isEnrtySession && __props.session.watch && __props.session.webinarSubURL && __props.webinarSubLabel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (openExternalLinkWithNewWindow(__props.session.webinarSubURL)), ["stop","prevent"])),
                          class: "btn btn-sm btn-accent w-100"
                        }, [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(__props.webinarSubLabel), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.eventAPIisAlive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.session.documents, (doc, p) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(p === __props.session.documents.length - 1 ? '' : 'mb-2'),
                            key: p
                          }, [
                            (doc.documentStatus === 'ready')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: _withModifiers(($event: any) => (openExternalLinkWithNewWindow(doc.documentURL)), ["stop","prevent"]),
                                  class: "btn btn-sm btn-dark w-100 session-document"
                                }, [
                                  _createElementVNode("span", _hoisted_34, "講演資料" + _toDisplayString(__props.session.documents.length != 1 ? '(' + (p + 1).toString() + ')' : '') + "ダウンロード", 1)
                                ], 8, _hoisted_33))
                              : _createCommentVNode("", true),
                            (doc.documentStatus === 'preparation')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                  _createElementVNode("span", _hoisted_36, "講演資料" + _toDisplayString(__props.session.documents.length != 1 ? '(' + (p + 1).toString() + ')' : '') + "は後日公開予定", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (doc.documentStatus === 'private')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                                  _createElementVNode("span", _hoisted_38, "講演資料" + _toDisplayString(__props.session.documents.length != 1 ? '(' + (p + 1).toString() + ')' : '') + "は非公開", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_39, [
              (__props.session.dtlable_status)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createVNode(_component_router_link, {
                      to: { path: '/', query: { seminar_session: 'seminar_' + __props.session.id }},
                      onClick: _withModifiers(($event: any) => (false), ["stop"]),
                      class: "h-100 text-nowrap btn-cols-max btn btn-outline-secondary w-100 session-detail",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("詳細")
                      ]),
                      _: 1
                    }, 8, ["to", "onClick"])
                  ]))
                : _createCommentVNode("", true),
              (__props.eventHolding && __props.session.regabel_status !== 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    (!__props.isCartInSession && !__props.isEnrtySession && __props.session.regabel_status !== 3)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "h-100 text-nowrap btn-cols-max btn btn-accent2 w-100 session-add",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (addItem(__props.session.layout_id)), ["stop","prevent"]))
                        }, [
                          _hoisted_42,
                          (__props.session.regabel_status === 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_43, "（残席わずか）"))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (!__props.isCartInSession && !__props.isEnrtySession && __props.session.regabel_status === 3)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_44, "（満席）"))
                      : _createCommentVNode("", true),
                    (__props.isCartInSession && !__props.isEnrtySession)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          class: "h-100 text-nowrap btn-cols-max btn btn-secondary w-100 session-remove",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (removeItem(__props.session.layout_id)), ["stop","prevent"]))
                        }, _hoisted_46))
                      : _createCommentVNode("", true),
                    (__props.isEnrtySession)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          type: "button",
                          class: "h-100 text-nowrap btn-cols-max btn btn-secondary w-100 session-cancel",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (cancelItem(__props.session)), ["stop","prevent"]))
                        }, _hoisted_48))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})